import { formatTime } from '@/format';
import type { DraftHandle } from '@/stores/drafts';

/**
 * Says out loud that a form was filled in from what was typed before.
 *
 * A form that quietly reappears with old values is its own kind of bug: the
 * person cannot tell what they typed now from what they typed yesterday. So it
 * is named, timed, and one click from being thrown away.
 */
export function DraftNotice({ draft, onStartAgain }: { draft: DraftHandle; onStartAgain: () => void }) {
  if (!draft.restoredAt) return null;

  return (
    <p className="draftnotice" role="status">
      <span aria-hidden="true">↩ </span>
      Unsaved work from {formatTime(draft.restoredAt)} was brought back.
      <button
        type="button"
        className="linkbutton"
        onClick={() => {
          draft.forget();
          onStartAgain();
        }}
      >
        Start again
      </button>
    </p>
  );
}
